import {TimePicker, TimePickerChangeEvent} from "@progress/kendo-react-dateinputs"
import {FieldRenderProps} from "@progress/kendo-react-form"
import dayjs from "dayjs"
import React, {useRef, useState} from "react"
import {RootState} from "../../../rootReducer"
import {useAppSelector} from "../../../store"

const TestTimePicker = (fieldRenderProps: FieldRenderProps) => {
    const {name, label, value, min, max, updateStateValue} = fieldRenderProps

    const [testTime, setTestTime] = useState<Date>(value)
    const timePickerRef = useRef<any>()
    const onStartEndTimeChange = (event: TimePickerChangeEvent) => {
        const timeValue = event.target.value
        const hours = dayjs(timeValue).get("hour")
        const mins = dayjs(timeValue).get("minutes")
        const updatedTime = dayjs(value).set("hours", hours).set("minutes", mins).second(0).toDate()
        setTestTime(updatedTime ?? value)
        if (event.nativeEvent.target.tagName !== "INPUT") {
            updateStateValue(updatedTime.toString())
        }
    }

    const dayAvailabilityInterval = useAppSelector(
        (state: RootState) => state.containers.motBooking.dvsaDayAvailability,
    )

    const setTestTiming = (date: Date) => {
        return dayjs(date).get("hour") === 0 ? null : dayjs(date).toDate()
    }

    const validationMessage = () => {
        if (dayjs(testTime).get("hour") === 0) return `${label} time is required`
        else if (!(new Date(testTime) > min) && name === "testEnd") {
            return `${label} time should be greater than start time`
        } else if (!(new Date(testTime) < max) && name === "testEnd") {
            return `${label} time should be between scheduled hours`
        } else if (!(new Date(testTime) >= min && new Date(testTime) <= max)) {
            return `${label} time is not between scheduled hours`
        } else return ""
    }

    const handleKeyDown = (ev: any) => {
        ev.preventDefault()
    }

    React.useEffect(() => {
        if (timePickerRef.current !== null) {
            timePickerRef.current.element.addEventListener("keydown", handleKeyDown)
        }
    }, [timePickerRef])

    React.useEffect(
        () => () => {
            if (timePickerRef.current !== null) {
                timePickerRef.current.element.removeEventListener("keydown", handleKeyDown)
            }
        },
        [timePickerRef],
    )

    return (
        <TimePicker
            id={`bkTimePicker_${name}`}
            required
            valid={
                (name !== "testEnd" &&
                    new Date(testTime) >= min &&
                    new Date(testTime) <= max &&
                    dayjs(testTime).get("hour") !== 0) ||
                (name === "testEnd" &&
                    new Date(testTime) > min &&
                    new Date(testTime) <= max &&
                    dayjs(testTime).get("hour") !== 0)
            }
            ref={timePickerRef}
            name={name}
            disabled={dayAvailabilityInterval === null}
            value={dayAvailabilityInterval === null ? null : setTestTiming(testTime)}
            label={label}
            onChange={onStartEndTimeChange}
            onBlur={e => {
                if (e.target.tagName === "INPUT") {
                    if (testTime !== value) {
                        updateStateValue(testTime)
                    }
                }
            }}
            steps={{hour: 1, minute: 5}}
            min={min}
            max={max}
            validationMessage={validationMessage()}
        />
    )
}

export default React.memo(TestTimePicker)
